import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Controller
import AppVersionUpdateController from './appVersionUpdateModal.controller';
import template from './appVersionUpdateModal.html';

// Dependencies
import appVersionServiceModule from '../../../service/AppVersionService';

const moduleName = 'recaps.editor.modals.appVersionUpdate';
let module = angular.module(moduleName, [
  uiModal,
  appVersionServiceModule.name
]);

module.controller('AppVersionUpdateController', AppVersionUpdateController);
module.factory('showAppVersionUpdateModal', ['$uibModal', 'AppVersionService', ($uibModal, AppVersionService) => {
  return props => {
    props = props || {};
    let modal = $uibModal.open({
      template: template,
      controller: AppVersionUpdateController,
      controllerAs: 'vm',
      size: props.size || 'sm',
      resolve: {
        AppVersionService: AppVersionService,
        message: () => props.message || props,
        title: () => props.title || '',
      }
    });
    return modal.result;
  };
}]);

export default module;
